import React from 'react';
import { parseISO } from 'date-fns';
import { UiDatePicker } from '../ui-kit/UiDatePicker';

/**
 * Ensures the value is a Date object, not a string.
 * date-fns v2+ requires Date objects, not strings.
 */
function ensureDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    // parseISO handles ISO date strings like "2025-01-15" or "2025-01-15T00:00:00Z"
    return parseISO(value);
  }
  return null;
}

/* eslint-disable react/prop-types */
export function UiDatePickerAdapter({ input, meta, ...rest }) {
  return (
    <UiDatePicker
      {...input}
      {...rest}
      selected={ensureDate(input.value)}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
